import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mockMultiProposal } from '@booking-overview/mocks/booking-proposal.mock';

@Injectable()
export class BookingProposalPlaygroundInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.router.routerState.snapshot.url.split('?')[0].endsWith('/playground/multi')) {
      if (req.method === 'GET') {
        return of(new HttpResponse({ body: mockMultiProposal }));
      }

      if (req.method === 'POST') {
        return of(new HttpResponse({ body: true }));
      }
    }

    return next.handle(req);
  }
}
